import { render, staticRenderFns } from "./summary-pension-and-insurance.vue?vue&type=template&id=0f0c107c&scoped=true&"
import script from "./summary-pension-and-insurance.vue?vue&type=script&lang=js&"
export * from "./summary-pension-and-insurance.vue?vue&type=script&lang=js&"
import style0 from "./summary-pension-and-insurance.vue?vue&type=style&index=0&id=0f0c107c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0c107c",
  null
  
)

export default component.exports